const gnavBtn = document.querySelector('.js-gnav-btn')
if (gnavBtn) {
  gnavBtn.addEventListener('click', function () {
    document.body.classList.toggle('open-gnav')
  })
}

const onMv = document.querySelector('.header[data-mv="true"]')
if (onMv) {
  const adjustOnMv = () => {
    if (window.scrollY <= 200) {
      onMv.classList.add('onMv')
    } else {
      onMv.classList.remove('onMv')
    }
  }

  window.addEventListener('scroll', adjustOnMv)
  adjustOnMv()
}
